<template>
    <div :class="$style.pas_container">
        <div :class="$style.pas_heading">{{ title }}</div>
        <div :class="$style.pas_content" :style="contentStyle">

            <nuxt-link v-for="item in items" :key="item.product_no" :class="$style.product" :to="getProductDetailUrl(item)" target="_blank">
                <div :class="$style.product_name">{{ item.product_name }}</div>

                <div :class="$style.product_details">
                    <div :class="$style.product_tag">
                        <img class="h-full object-cover" :src="iconUrl" />
                    </div>
                    <div :class="$style.product_price">
                        <span :class="$style.product_price_curr">¥</span>
                        <span :class="$style.product_price_num">{{ item.sale_price }}</span>
                        <span :class="$style.product_price_unit">起/人</span>
                    </div>
                </div>
            </nuxt-link>
        </div>

    </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { random } from 'lodash';
import { buildProductDetailLink } from '~/utils/product';

export default defineComponent({
    name: 'PlatformAdvertStair',
    props: {
        title: String,
        items: {
            type: Array,
            default: () => []
        },
        background_color: String,
        iconUrl: String
    },
    setup() {
        const getProductDetailUrl = (product) => {
            return buildProductDetailLink({
                product_type: product.product_type,
                product_no: product.product_no,
                is_tripartite_product: product.is_tripartite_product
            })
        }
        return {
            getProductDetailUrl
        }
    },
    computed: {
        contentStyle(){
            // const colors = ['#FFF8EF', '#EBF3FA'];
            // const index= random(0, 1);
            return {
                background: `linear-gradient(135deg, ${ this.background_color || '#FFF8EF' } 0%, #FFFFFF 100%)`
            }
        }
    }
})
</script>

<style lang="scss" module>
.pas_container {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.pas_heading {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.pas_content {
  border-radius: 0.25rem;
  padding-bottom: 0.75rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.product {
  border-bottom-width: 1px;
  display: block;
  padding: 1rem;
  padding-bottom: 0.625rem;
  position: relative;
}
.product:last-child {
  border-bottom-width: 0px;
}
.product:hover .product_name {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.product_name {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 0.375rem;
}
.product_tag {
  height: 1.5rem;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
}
.product_price {
  margin-left: auto;
  white-space: nowrap;
  font-size: 0;
}
.product_price_curr {
  font-size: 1rem;
  line-height: 1.5rem;
}
.product_price_curr, .product_price_num {
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
}
.product_price_num {
  font-weight: 500;
  font-size: 20px;
}
.product_price_unit {
  padding-left: 2px;
  font-size: 14px;
}
</style>